export const getFromSessionStorage = (key: string) => {
  if (typeof window === 'undefined' || !sessionStorage) {
    return null;
  }

  const storageData = sessionStorage?.getItem(key);
  if (storageData === 'undefined' || storageData === 'null') {
    return null;
  }

  try {
    return JSON.parse(storageData);
  } catch (e) {
    return storageData;
  }
};
